module.exports = new __parcel__URL__("sender-icon.7974c4a3.png").toString();